import { createContext, useContext, useEffect, useState } from "react";

const dict = {
    zh: {
        brand: "9CUT SALON",
        brandSub: "深夜理发室",
        nav: { story: "深夜故事", services: "服务价目", gallery: "作品展示", reviews: "客人评价", booking: "立即预约", admin: "管理入口" },
        status: { open: "营业中", closed: "已打烊", hours: "21:00 – 04:00" },
        hero: {
            badge: "深夜专属 · 仅限预约",
            l1: "城市睡了，",
            l2: "剪刀醒了。",
            sub: "9CUT 是一家只在深夜营业的居家理发工作室。专为下班太晚、白天没空剪发的你，留一盏灯、一把椅子、一杯热饮。",
            cta1: "预约今晚的位子",
            cta2: "查看服务价目",
            stats: [
                { v: "1对1", l: "私人空间" },
                { v: "0", l: "排队等待" },
                { v: "21:00–04:00", l: "只接深夜" },
            ],
            hudOpen: "午夜班次进行中",
            hudClosed: "今晚 21:00 开门",
        },
        marquee: [
            "21:00 – 04:00 深夜服务",
            "居家私人理发工作室",
            "仅限预约",
            "服务夜班族与深夜创作者",
            "热毛巾修面 · 精剪造型",
        ],
        story: {
            overline: "为什么是深夜",
            title: "为时间表不属于白天的人",
            p1: "工程师、医生、餐饮人、代驾司机……你们的下班时间，就是普通理发店的打烊时间。9CUT 存在的意义，就是让「想剪个头发」这件事，不再需要请假。",
            p2: "工作室就在我家里。没有嘈杂的等位区，没有推销办卡，只有一位理发师、一位客人。深夜的手冲咖啡或一杯威士忌，配上合适的音乐和灯光。",
            p3: "主理人 8 年以上理发经验，专注现代渐变剪裁、剪刀造型与胡须雕刻。",
            card2t: "居家工作室氛围",
            card2items: ["手冲咖啡 / 威士忌招待", "私人 1 对 1 服务", "深夜歌单与氛围灯光", "免费停车位"],
            card3t: "主理人",
            card3role: "资深理发师 · 8年+",
            card3d: "擅长美式渐变、纹理碎发、油头与直剃修面，深夜状态反而更专注。",
        },
        services: {
            overline: "服务与价目",
            title: "明码标价，深夜同价",
            sub: "所有项目均为深夜时段价格，无任何隐藏费用。选择项目后直接预约。",
            select: "选这个",
            duration: "时长",
        },
        gallery: {
            overline: "作品展示",
            title: "深夜出品",
            sub: "每一颗头，都是凌晨时分的作品。",
            filters: { all: "全部", Haircut: "剪裁", "Beard & Shave": "修面胡须", Executive: "商务造型", Coloring: "染发" },
        },
        reviews: {
            overline: "夜猫子评价",
            title: "他们都是深夜的常客",
        },
        booking: {
            overline: "预约系统",
            title: "锁定你的深夜时段",
            sub: "四步完成预约。成功后会收到预约编号，详细地址与停车指引将随确认信息发送。",
            steps: ["选择服务", "选择日期", "选择时间", "留下联系方式"],
            serviceLabel: "服务项目",
            dateLabel: "选择日期（未来7天）",
            slotLabel: "深夜时段",
            bookedTag: "已约",
            closedTag: "休息",
            nameLabel: "怎么称呼你",
            namePh: "姓名 / 昵称",
            phoneLabel: "联系电话",
            phonePh: "手机或微信同号",
            emailLabel: "邮箱（可选）",
            emailPh: "接收确认邮件：详细地址 + 停车指引",
            notesLabel: "备注（可选）",
            notesPh: "想要的发型、参考图说明、过敏情况等",
            next: "下一步",
            back: "上一步",
            submit: "确认预约",
            submitting: "提交中…",
            errFill: "请先完成当前步骤",
            errSubmit: "预约提交失败，请稍后再试或电话联系",
            errSlotTaken: "这个时段刚被约走了，请换一个时间",
            successTitle: "预约成功",
            successSub: "你的深夜位子已锁定，确认信息会尽快发送给你。",
            successEmailNote: "确认邮件（含详细地址与停车指引）正在发送，没收到请查垃圾邮件。",
            refLabel: "预约编号",
            summaryLabel: "预约详情",
            addrNote: "工作室地址：84 Winmalee Dr, Glen Waverley VIC 3150 · 门前街道免费停车。",
            another: "再约一个",
        },
        footer: {
            addr: "84 Winmalee Dr, Glen Waverley VIC 3150（居家工作室）",
            hours: "每晚 21:00 – 次日 04:00",
            contact: "预约咨询",
            parking: "门前 Winmalee Dr 街道免费停车",
            rights: "© 2026 9CUT SALON · 深夜理发室",
        },
        admin: {
            title: "9CUT 管理后台",
            sub: "输入管理密码查看预约",
            passwordPh: "管理密码",
            login: "进入后台",
            wrongPw: "密码不正确",
            logout: "退出登录",
            total: "全部预约",
            pending: "待确认",
            tonight: "今晚预约",
            filterAll: "全部",
            status: { pending: "待确认", confirmed: "已确认", completed: "已完成", cancelled: "已取消" },
            daysOff: "休息日设置",
            daysOffNote: "被关闭的日期，客人预约时将无法选择。",
            addOff: "关闭这天",
            offEmpty: "当前没有休息日",
            actions: { confirm: "确认", complete: "完成", cancel: "取消", del: "删除" },
            empty: "暂无预约",
            cols: { guest: "客人", service: "服务", time: "时间", status: "状态", notes: "备注", ops: "操作" },
            backHome: "返回网站",
        },
        weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    },
    en: {
        brand: "9CUT SALON",
        brandSub: "Midnight Barber",
        nav: { story: "Story", services: "Services", gallery: "Gallery", reviews: "Reviews", booking: "Book Now", admin: "Admin" },
        status: { open: "OPEN NOW", closed: "CLOSED", hours: "21:00 – 04:00" },
        hero: {
            badge: "MIDNIGHT ONLY · APPOINTMENT ONLY",
            l1: "The city sleeps.",
            l2: "My clippers wake.",
            sub: "9CUT is a home barber studio that only opens after dark — for everyone whose work schedule never fits a 9-to-5 barbershop. One chair, one light, one hot drink waiting for you.",
            cta1: "Book Tonight's Chair",
            cta2: "Services & Prices",
            stats: [
                { v: "1-on-1", l: "Private Studio" },
                { v: "0", l: "Waiting Time" },
                { v: "21–04", l: "Midnight Only" },
            ],
            hudOpen: "MIDNIGHT SHIFT LIVE",
            hudClosed: "OPENS TONIGHT 21:00",
        },
        marquee: [
            "21:00 – 04:00 MIDNIGHT SERVICE",
            "PRIVATE HOME BARBER STUDIO",
            "APPOINTMENT ONLY",
            "SERVING NIGHT SHIFT WORKERS & LATE CREATIVES",
            "HOT TOWEL SHAVE & PRECISION CUTS",
        ],
        story: {
            overline: "WHY MIDNIGHT",
            title: "For people whose schedule doesn't belong to daytime",
            p1: "Engineers, ER doctors, chefs, rideshare drivers — your clock-out time is exactly when every barbershop pulls its shutters. 9CUT exists so that 'getting a haircut' never requires taking leave again.",
            p2: "The studio is my home. No noisy waiting area, no membership upsells — just one barber and one guest. Late-night drip coffee or a glass of whisky, with the right music and lighting.",
            p3: "Your barber has 8+ years of experience, focused on modern fades, scissor work and beard sculpting.",
            card2t: "Home Studio Vibe",
            card2items: ["Drip coffee / whisky on the house", "Private 1-on-1 service", "Late-night playlist & mood lighting", "Free parking"],
            card3t: "The Barber",
            card3role: "Master Barber · 8+ yrs",
            card3d: "Specialised in skin fades, textured crops, classic pompadours and straight-razor shaves. Sharper after midnight.",
        },
        services: {
            overline: "SERVICES & PRICES",
            title: "Honest pricing, same rate after dark",
            sub: "Every item is priced for the midnight shift — no hidden fees. Pick one and book straight away.",
            select: "Select",
            duration: "Duration",
        },
        gallery: {
            overline: "GALLERY",
            title: "Made after midnight",
            sub: "Every head below left the chair in the small hours.",
            filters: { all: "All", Haircut: "Cuts", "Beard & Shave": "Beard & Shave", Executive: "Executive", Coloring: "Color" },
        },
        reviews: {
            overline: "NIGHT OWL REVIEWS",
            title: "Regulars of the midnight shift",
        },
        booking: {
            overline: "BOOKING",
            title: "Lock in your midnight slot",
            sub: "Four steps. You'll get a booking reference; the exact address and parking guide arrive with confirmation.",
            steps: ["Service", "Date", "Time", "Details"],
            serviceLabel: "Service",
            dateLabel: "Pick a date (next 7 days)",
            slotLabel: "Midnight slots",
            bookedTag: "Booked",
            closedTag: "Closed",
            nameLabel: "Your name",
            namePh: "Name / nickname",
            phoneLabel: "Phone",
            phonePh: "Mobile / WeChat",
            emailLabel: "Email (optional)",
            emailPh: "Get a confirmation email with address & parking guide",
            notesLabel: "Notes (optional)",
            notesPh: "Style you want, reference photos, allergies…",
            next: "Next",
            back: "Back",
            submit: "Confirm Booking",
            submitting: "Submitting…",
            errFill: "Please complete this step first",
            errSubmit: "Booking failed — please retry or contact us directly",
            errSlotTaken: "That slot was just taken — pick another time",
            successTitle: "Booking Confirmed",
            successSub: "Your midnight chair is locked. Confirmation details will reach you shortly.",
            successEmailNote: "A confirmation email with the address & parking guide is on its way — check spam if missing.",
            refLabel: "Reference",
            summaryLabel: "Booking Summary",
            addrNote: "Find us at 84 Winmalee Dr, Glen Waverley VIC 3150 · free street parking right out front.",
            another: "Book another",
        },
        footer: {
            addr: "84 Winmalee Dr, Glen Waverley VIC 3150 · Home studio",
            hours: "Nightly 21:00 – 04:00",
            contact: "Booking enquiries",
            parking: "Free street parking right out front on Winmalee Dr",
            rights: "© 2026 9CUT SALON · Midnight Barber",
        },
        admin: {
            title: "9CUT Admin",
            sub: "Enter the admin passcode to view bookings",
            passwordPh: "Admin passcode",
            login: "Enter",
            wrongPw: "Wrong passcode",
            logout: "Log out",
            total: "Total",
            pending: "Pending",
            tonight: "Tonight",
            filterAll: "All",
            status: { pending: "Pending", confirmed: "Confirmed", completed: "Completed", cancelled: "Cancelled" },
            daysOff: "Days Off",
            daysOffNote: "Guests can't pick blocked dates in the booking form.",
            addOff: "Block this day",
            offEmpty: "No days off set",
            actions: { confirm: "Confirm", complete: "Complete", cancel: "Cancel", del: "Delete" },
            empty: "No bookings yet",
            cols: { guest: "Guest", service: "Service", time: "Time", status: "Status", notes: "Notes", ops: "Actions" },
            backHome: "Back to site",
        },
        weekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("9cut-lang") || "en");
    useEffect(() => {
        localStorage.setItem("9cut-lang", lang);
        document.documentElement.lang = lang === "zh" ? "zh-CN" : "en";
    }, [lang]);
    return (
        <LangContext.Provider value={{ lang, setLang, t: dict[lang] }}>
            {children}
        </LangContext.Provider>
    );
}

export function useLang() {
    return useContext(LangContext);
}
